export { default } from "./ManyToManyList";
